import { Button, ButtonGroup, Card, Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const PreQualifierQuestionPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/LocationClassCodePage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/RatingInformationPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Pre-Qualifier Questions
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Does the Applicant engage sub-contractors or independent
                                      contractors?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Does the Applicant engage sub-contractors or independent contractors?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="subcontractors"
                                          className="me-2"
                                          id="yes-radio"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="subcontractors"
                                          className="me-2"
                                          id="no-radio"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Does the Applicant use motor vehicles for business purposes?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Does the Applicant use motor vehicles for business purposes?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="business-vehicles"
                                          className="me-2"
                                          id="yes-radio"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="business-vehicles"
                                          className="me-2"
                                          id="no-radio"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Does the Applicant provide group transportation, where five or
                                      more employees are in a vehicle at one time?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Does the Applicant provide group transportation, where five or more employees are in a vehicle at one time?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="group-transportation"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="group-transportation"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Any prior coverage declined/cancelled/non-renewed (other than
                                      for pandemic, risk class of business or carrier no longer
                                      writing) in the last three (3) years?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Any prior coverage declined/cancelled/non-renewed (other than for pandemic, risk class of business or carrier no longer writing) in the last three (3) years?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      />
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="prior-coverage"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="prior-coverage"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Are employee health plans provided?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Are employee health plans provided?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="employee-health-plans"
                                          className="me-2"
                                          id="yes-radio"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          name="employee-health-plans"
                                          className="me-2"
                                          id="no-radio"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Do you lease employees to or from other employers?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Do you lease employees to or from other employers?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="lease-employees"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="lease-employees"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Does Applicant own, operate or lease aircraft/watercraft?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Does Applicant own, operate or lease aircraft/watercraft?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      />
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="aircraft-watercraft"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="aircraft-watercraft"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreQualifierQuestionPage;
